import React from 'react'
import { IntegrationsShopifySec } from './integrationsShopifySec'

export const IntegrationsShopify = () => {
  return (
    <IntegrationsShopifySec />
  )
}
